import {Component, Input} from '@angular/core';
import {Delegation} from "../types/delegation";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";

@Component({
  selector: 'delegation-box',
  templateUrl: './delegation-box.component.html',
  styleUrls: ['./delegation-box.component.scss']
})
export class DelegationBoxComponent {
  @Input() delegation: Delegation;
  @Input() i18n: Map<string, string>;

  constructor(private sanitizer: DomSanitizer) { }

  sanitize(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

}
